<div>
    <br />
    <h3 class="print-hide">{{ 'Saldotransaktioner' | translate }}</h3>

    <section class="shopify-top-up print-hide" *ngIf="isShopifyStore">
        <div class="top-up-copy">
            <h4>{{ 'Top up credits with Shopify' | translate }}</h4>
            <p>
                {{ 'Credits are always added in SEK. Shopify bills the converted amount through your app pricing plan.' | translate }}
            </p>
        </div>

        <div *ngIf="planStatusLoading">
            {{ 'Checking Shopify app pricing plan...' | translate }}
        </div>

        <div *ngIf="!planStatusLoading && !canTopUpWithShopify">
            <p>
                {{ 'Select a Shopify app pricing plan before topping up credits.' | translate }}
            </p>
            <p *ngIf="shopifyPlanStatus?.message">
                {{ shopifyPlanStatus.message | translate }}
            </p>
            <button mat-raised-button color="primary" *ngIf="shopifyPlanStatus?.planSelectionUrl" (click)="openShopifyPlanSelection()">
                {{ 'Select Shopify plan' | translate }}
            </button>
        </div>

        <div class="top-up-form" *ngIf="!planStatusLoading && canTopUpWithShopify">
            <mat-form-field appearance="fill">
                <mat-label>{{ 'Credits to top up' | translate }}</mat-label>
                <input matInput type="number" min="1" [(ngModel)]="topUpCredits" (ngModelChange)="updateShopifyTopUpQuote()">
            </mat-form-field>
            <div class="top-up-quote" *ngIf="topUpQuote">
                {{ utility.numberFormat(topUpQuote.credits, true) }} SEK =
                {{ utility.numberFormat(topUpQuote.amount, true) }} {{ topUpQuote.currency }}
                <span *ngIf="topUpQuote.currency !== topUpQuote.requestedCurrency">
                    ({{ 'billing currency fallback' | translate }})
                </span>
            </div>
            <button mat-raised-button color="primary" [disabled]="topUpLoading || !topUpQuote" (click)="startShopifyTopUp()">
                {{ topUpLoading ? ('Adding credits...' | translate) : ('Add credits via Shopify' | translate) }}
            </button>
        </div>
        <div class="positive-color fullwidth" *ngIf="topUpMessage">{{ topUpMessage | translate }}</div>
        <div class="negative-color fullwidth" *ngIf="topUpError">{{ topUpError | translate }}</div>
    </section>

    <section class="transaction-list-section">
        <div class="transaction-list-header print-hide">
            <h4>{{ 'Transactions' | translate }}</h4>
            <mat-form-field appearance="fill">
                <mat-label>{{ 'Period' | translate }}</mat-label>
                <mat-date-range-input [rangePicker]="picker">
                    <input matStartDate [placeholder]="'Startdatum' | translate" [(ngModel)]="periodStart" (dateChange)="onPeriodChange()">
                    <input matEndDate [placeholder]="'Slutdatum' | translate" [(ngModel)]="periodEnd" (dateChange)="onPeriodChange()">
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
            </mat-form-field>
        </div>

        <table class="fullwidth styled compact credit-transactions" *ngIf="globals.currentUser">
            <tr>
                <th>{{ 'Order' | translate }}</th>
                <th>{{ 'Datum' | translate }}</th>
                <th>{{ 'Beskrivning' | translate }}</th>
                <th class="align-right">{{ 'Detaljkostnad' | translate }}</th>
                <th class="align-right">{{ 'Printkostnad' | translate }}</th>
                <th class="align-right">{{ 'Fraktkostnad' | translate }}</th>
                <th class="align-right">{{ 'Summa' | translate }}</th>
            </tr>

            <ng-container *ngFor="let transaction of transactions">
                <tr>
                    <td>
                        <a *ngIf="transaction.posterOrderNumber" [href]="globals.storeUrl('/poster-orders/' + transaction.posterOrderId, globals.storeSettings._id, true)" target="_blank">
                            {{transaction.posterOrderNumber}}
                        </a>
                    </td>
                    <td>{{transaction.created | date: 'yyyy-MM-dd HH:mm'}}</td>
                    <td>{{transaction.description}}</td>
                    <td class="align-right"></td>
                    <td class="align-right">
                        <span *ngIf="transaction.metadata && transaction.metadata.fee">
                            {{utility.numberFormat(transaction.metadata.fee.printCost, true)}}
                        </span>
                    </td>
                    <td class="align-right">
                        <span *ngIf="transaction.metadata && transaction.metadata.fee">
                            {{utility.numberFormat(transaction.metadata.fee.shippingCost, true)}}
                        </span>
                    </td>
                    <td class="align-right">{{utility.numberFormat(displayAmount(transaction), true)}}</td>
                </tr>
                <ng-container *ngIf="transaction.metadata && transaction.metadata.fee && transaction.metadata.fee && transaction.metadata.fee.rows">
                    <tr class="details-row" *ngFor="let row of transaction.metadata.fee.rows">
                        <td></td>
                        <td></td>
                        <td>
                            <span class="material-symbols-outlined" style="user-select: none;">subdirectory_arrow_right</span>
                            {{row.description}}
                        </td>
                        <td class="align-right">
                            {{utility.numberFormat(row.amount, true)}}
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                </ng-container>
            </ng-container>
            <tr class="totals-row">
                <th>{{ 'Total' | translate }}</th>
                <th></th>
                <th></th>
                <th></th>
                <th class="align-right">
                    {{utility.numberFormat(transactionTotals.printCost, true)}}
                </th>
                <th class="align-right">
                    {{utility.numberFormat(transactionTotals.shippingCost, true)}}
                </th>
                <th class="align-right">
                    {{utility.numberFormat(transactionTotals.totalCost, true)}}
                </th>
            </tr>
        </table>
    </section>
</div>
